import { toast } from 'sonner';

import { ModalsManager } from '@/components/modals/modalsManager';
import { isConnectableDeviceToolkit } from '@/integrations/device-integrations';
import {
  handleContactsConnect,
  handleEventKitConnect,
} from '@/integrations/integration-handlers';
import {
  ContactsPermissionModal,
  EventKitPermissionModal,
} from '@/integrations/integrations.modals';
import { integrationsStore } from '@/integrations/integrations.store';
import {
  trackOnDeviceConnectClicked,
  type OnDeviceSurface,
} from '@/integrations/integrations.utils';

export async function connectAppleNativeToolkit(
  toolkitName: 'applereminders' | 'applecontacts',
  displayName: string,
  surface: OnDeviceSurface
): Promise<void> {
  if (isConnectableDeviceToolkit(toolkitName)) {
    trackOnDeviceConnectClicked(toolkitName, 'builtin', surface);
  }
  integrationsStore.markPending(toolkitName);
  try {
    if (toolkitName === 'applereminders') {
      const result = await handleEventKitConnect(toolkitName);
      if (result?.needsSystemSettings) {
        ModalsManager.show(EventKitPermissionModal, { type: 'reminders' });
      }
    } else {
      const result = await handleContactsConnect();
      if (result?.needsSystemSettings) {
        ModalsManager.show(ContactsPermissionModal, {});
      }
    }
  } catch (error) {
    console.error(
      `Unexpected error in ${toolkitName === 'applereminders' ? 'EventKit' : 'Contacts'} action:`,
      error
    );
    toast.error(`Unexpected error: ${displayName}`);
  } finally {
    integrationsStore.unmarkPending(toolkitName);
  }
}
